import type { FaireProductEntity } from "../../entity_types/product";

export const p_gcqwf6tpfq: FaireProductEntity = {
  token: "p_gcqwf6tpfq",
  type: "product",
  name: "Black Bandana Fringe Vest",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/a478ec46b870410ab8b51077609331467ea28e8a5a765122f4ee149f61bd445b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5fa492916cad9bb5a4644bcfd404a87a6d626cfeb9b1e89dbe2bf922aa370441.jpeg",
    "https://cdn.faire.com/fastly/f5af397952d8908fd2616b6715107f3b8ecb596c5c8e349e5e31a139f8cfc926.jpeg",
    "https://cdn.faire.com/fastly/5b3478b9bdd20e54efce8ac9bb031e328a577a935967682534e13ba0c251a689.jpeg",
    "https://cdn.faire.com/fastly/476339d0b0c2af7f806a97202e4218e21c5950e2f97894ac96f59ed5d03063c7.jpeg"
  ],
  priceDollars: 33.95,
  description: "Black Bandana Fringe Vest featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, sleeveless silhouette, and long fringe trim along the front and hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:53.027Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
